import { render, staticRenderFns } from "./simpleTextShadow.vue?vue&type=template&id=2c07f278&"
import script from "./simpleTextShadow.vue?vue&type=script&lang=ts&"
export * from "./simpleTextShadow.vue?vue&type=script&lang=ts&"
import style0 from "./simpleTextShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports